import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/reply-logo-compact.png'


const _hoisted_1 = {
  key: 0,
  class: "mobile-menu__backdrop"
}
const _hoisted_2 = {
  key: 0,
  class: "mobile-menu"
}
const _hoisted_3 = { class: "mobile-menu__header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "reply-logo-compact"
}, null, -1)
const _hoisted_5 = { class: "mobile-menu__buttons" }
const _hoisted_6 = ["onClick"]

import { useAccountStore } from '@/stores/account';
import { useDialogStore } from '@/stores/dialogs';
import { useUiStore } from '@/stores/ui';
import { computed } from 'vue';
import { RouterLink, useRouter } from 'vue-router';
import BillingInfoDialog from './dialogs/BillingInfoDialog.vue';
import SettingsDialog from './dialogs/SettingsDialog.vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';
import VIconButton from './VIconButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheMobileMenu',
  setup(__props) {

const accountStore = useAccountStore()
const uiStore = useUiStore()
const router = useRouter()
const dialogStore = useDialogStore()

const items = [
  { title: "Dashboard", to: "/" },
  // { title: "Auto-Replies", to: "/reply" },
  // { title: "Blocklists", to: "/blocklists" },
  // { title: "Word Stats", to: "/word-stats/bms" },
  { title: "Activity Logs", to: "/logs" },
  { title: "Settings", dialog: SettingsDialog, onClick() {
    dialogStore.open(SettingsDialog)
  } },
  { title: "Billing", dialog: BillingInfoDialog, onClick() {
    dialogStore.open(BillingInfoDialog)
  } },
  { title: "Log out", class: "red", onClick() { 
    accountStore.logout() 
    router.push("/auth")
  } }
]

const close = () => {
  uiStore.mobileMenu = false
}

const click = (item: typeof items[0]) => {
  if (item.onClick) {
    item.onClick()
  }
  close()
}

const currentPath = computed(() => router.currentRoute.value.matched[1]?.path)

const activeItem = computed(() => {
  if (dialogStore.dialog) {
    for (let item of items) {
      if (item.dialog && item.dialog === dialogStore.dialog as any) return item
    }
  }
  for (let item of items) {
    if (item.to && item.to === currentPath.value) return item   
  }
  return null
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(uiStore).mobileMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(uiStore).mobileMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(VIconButton, {
                  class: "gray",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(CloseIcon)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (!!item.to)
                      ? (_openBlock(), _createBlock(_unref(RouterLink), {
                          key: 0,
                          to: item.to,
                          class: _normalizeClass([ { active: item === _unref(activeItem) }, item.class ]),
                          onClick: close
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: _normalizeClass(item.class),
                          onClick: ($event: any) => (click(item))
                        }, _toDisplayString(item.title), 11, _hoisted_6))
                  ], 64))
                }), 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})